import type { AgentMergeIncidentsPlan } from '../../../../types';
import type { ToolRendererArgs } from '../../types';

export function buildNewArgsFromPlan(
  plan: AgentMergeIncidentsPlan,
): Record<string, unknown> {
  const out: Record<string, unknown> = {
    goal: plan.goal,
    primary_incident_id: plan.primaryIncidentId,
    incident_ids: plan.sourceIncidentIds,
  };
  const title = plan.title?.trim();
  const summary = plan.userSummary?.trim();
  if (title) {
    out.title = title;
  }
  if (summary) {
    out.user_summary = summary;
  }
  return out;
}

export function planFromToolArgs(
  toolArgs: ToolRendererArgs,
  toolCallId: string,
): AgentMergeIncidentsPlan {
  const primary = String(toolArgs?.primary_incident_id ?? '');
  const sources = (toolArgs?.incident_ids as string[] | undefined) ?? [];
  return {
    toolCallId,
    goal: String(toolArgs?.goal ?? ''),
    primaryIncidentId: primary,
    sourceIncidentIds: [...sources],
    title: toolArgs?.title as string | undefined,
    userSummary: toolArgs?.user_summary as string | undefined,
  };
}
